import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { titleForPath } from '../routeTitles';

/** Sets document.title from the current route. Renders nothing. */
export default function RouteTitle() {
    const { pathname } = useLocation();
    useEffect(() => {
        document.title = titleForPath(pathname);
    }, [pathname]);
    return null;
}
